import { useMsalRoles } from './useMsalRoles';

export const useIsAdmin = () => {
    const roles = useMsalRoles();
    return roles.includes('admin');
};
